import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './DatePicker.module.scss';
import Text from '../../Base/Text/Text';
import DatePickerReact, { registerLocale } from 'react-datepicker';
import { joinClasses } from '../../../Utils/className.util';
import { cs, sk, es, enGB, hu, uk, ru, de, fr } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { useAppContext } from '../../../Services/AppContext';
// @ts-ignore
import moment, { isMoment, Moment } from 'moment';
import { FieldError } from 'react-hook-form';
import { useValidation } from '../../Utils/Validation';
import useTranslation from '../../../Hooks/useTranslation';

const ll = {
	cs: cs,
	sk: sk,
	hu: hu,
	en: enGB,
	ru: ru,
	uk: uk,
	es: es,
	de: de,
	fr: fr,
};
for (const l in ll) {
	registerLocale(l, ll[l]);
}

interface IDatePicker {
	onChange?: any;
	value?: Moment;
	placeholder?: string;
	required?: boolean;
	usePortal?: boolean;
	minDate?: Moment;
	maxDate?: Moment;
	error?: FieldError;
	disabled?: boolean;
	rules?: any[];
}

export default function DatePicker(props: IDatePicker) {
	const {
		onChange,
		value,
		usePortal,
		placeholder,
		minDate,
		maxDate,
		disabled,
		rules,
	} = props;
	const { t } = useTranslation();
	const [startDate, setStartDate] = useState(
		value ? (isMoment(value) ? value : moment(value)) : null,
	);
	const { translation, language, dateFormat } = useAppContext();
	const { fillErrorMessage } = useValidation();

	const [min, setMin] = useState(minDate?.toDate());
	const [max, setMax] = useState(maxDate?.toDate());

	const handleOnChange = (e: any) => {
		const date = Boolean(e) ? moment(e) : e;

		onChange?.(date);
		setStartDate(date);
	};

	useEffect(() => {
		const tempValue = value ? (isMoment(value) ? value : moment(value)) : null;

		setStartDate(tempValue);
	}, [value]);

	const handleRules = (item: any) => {
		if (item === 'today') {
			return moment().toDate();
		}

		if (['day', 'month', 'year'].includes(item?.period)) {
			return moment().add(item[item?.period], item?.period).toDate();
		}
		return undefined;
	};

	useEffect(() => {
		rules?.forEach(item => {
			if (item?.rule === 'min') {
				setMin(handleRules(item?.value));
			} else if (item?.rule === 'max') {
				setMax(handleRules(item?.value));
			}
		});
	}, [rules]);

	return (
		<div className={styles.wrapper}>
			<DatePickerReact
				minDate={min}
				maxDate={max}
				placeholderText={placeholder ?? t('base.shared.pick')}
				portalId={usePortal ? 'datepicker-portal' : undefined}
				selected={
					isMoment(startDate)
						? startDate.isValid()
							? startDate.toDate()
							: null
						: startDate
				}
				dateFormat={translation['base.dateFormatJsReact']}
				locale={language}
				onChange={handleOnChange}
				className={joinClasses([
					'form-control',
					styles.input,
					props.error ? styles.invalid : '',
				])}
				disabled={disabled}
			/>
			{props.error && (
				<div className={styles.errorMessage}>
					<Text tx={fillErrorMessage(props.error)} inline={true} />
				</div>
			)}
		</div>
	);
}
